import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  RdsButtonComponent,
  RdsProgressBarComponent,
} from '@rds/angular-components';

import { AuthService } from '@bookly/shared';

@Component({
  selector: 'bsh-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, RdsButtonComponent, RdsProgressBarComponent],
})
export class LoginComponent {
  readonly #authService = inject(AuthService);

  protected readonly isLoginPending = this.#authService.isLoginPending;

  protected login() {
    this.#authService.login();
  }
}
